<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <p-autoComplete (completeMethod)="filterUsers($event)" #autoComplete
                  (onSelect)="onSelect($event)"
                  (onClear)="onClear()"
                  [disabled]="disabled"
                  [(ngModel)]="user" [autoHighlight]="true"
                  [dropdown]="false" [forceSelection]="true"
                  [minLength]="1"
                  [size]="30"
                  [suggestions]="filteredCustomers" appendTo="body" dataKey="username"
                  field="username">
    <ng-template let-user pTemplate="item">
      <div class="ui-helper-clearfix">
        <div
          class="container"
          style="cursor: pointer;"
        >
          <div *ngIf="user === null" class="name">None</div>
          <div *ngIf="user !== null" class="name clamp-one-row">{{getWorkerName(user)}}</div>
          <div class="overlay-button"></div>
        </div>
      </div>
    </ng-template>
  </p-autoComplete>
</app-generic-field>
